// 構想提案のフィールド定義 — 画面側の唯一の正本。
// 新規登録（DevCreate）・手動編集（ConceptEdit）・詳細の読み取り表示（DevDetail）が
// すべてこれを読む。バックエンドは routers/eng_development.CONCEPT_FIELDS が正本で、
// 必須判定・印刷・履歴のフィールド順はそちらから導出される。
// 担当者（owner）はここに含めない — 独自の停止条件と独自の更新経路を持つため。
export const CONCEPT_FIELDS = [
  { key: 'title', label: '案件名', required: true, type: 'text', wide: true },
  { key: 'background', label: '背景', required: true, type: 'textarea', rows: 3, wide: true },
  { key: 'purpose', label: '目的', required: true, type: 'textarea', rows: 3, wide: true },
  { key: 'intended_use', label: '想定する利用先', required: true, type: 'textarea', rows: 2 },
  { key: 'target_spec', label: '目標仕様', required: true, type: 'textarea', rows: 3, wide: true },
  { key: 'estimated_cost', label: '想定コスト', required: false, type: 'text' },
  { key: 'current_problem', label: '現状の問題', required: false, type: 'textarea', rows: 2 },
  { key: 'expected_effect', label: '期待する効果', required: false, type: 'textarea', rows: 2 },
  { key: 'constraints', label: '制約条件', required: false, type: 'textarea', rows: 2 },
  { key: 'notes', label: '備考', required: false, type: 'textarea', rows: 2 },
];

export const CONCEPT_FIELD_MAP = Object.fromEntries(CONCEPT_FIELDS.map((f) => [f.key, f]));

export const CONCEPT_LABEL = (key) => CONCEPT_FIELD_MAP[key]?.label || key;

export const emptyConcept = () =>
  Object.fromEntries(CONCEPT_FIELDS.map((f) => [f.key, '']));
